import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import theme from '../../../theme';
import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';
import { Building } from '../primitive/Icons';

type Props = ClassAttributes<HTMLElement> & {
  name: string;
  className?: string;
};

const OrganizationNameWithIcon = ({ name, className }: Props) => {
  return (
    <Root noWrap className={className}>
      <OrganizationIcon />
      {name}
    </Root>
  );
};

const Root = styled(Typography)(flexibleLayoutContainer({ direction: 'row', alignItems: 'center' }), {
  color: theme.palette.grey[800],
});

const OrganizationIcon = styled(Building)({
  marginRight: 4,
});

export default OrganizationNameWithIcon;
